import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { LoadAllSchool, UpdateSchool } from '../../../actions/Activites/School'
import ModalAddSchoolBible from '../../../modal/admin/actvites/ModalAddSchoolBible'
import { baseUrl } from '../../../nametitle/dataUrl'
import LoaderBootStrap from '../dasboard/LoaderBootStrap'
import { MdBlock, MdClose, MdOutlineRemoveRedEye, MdViewStream } from 'react-icons/md'
import  {ImBlocked} from "react-icons/im";


const ListSchoolBibleAdmin = () => {
  const navigate = useNavigate()

  const [idSchool, setidSchool] = useState('')
  const [coverPicture, setcoverPicture] = useState('')
  const [title, settitle] = useState('')
  const [description, setdescription] = useState('')
  const [audio, setaudio] = useState('')
  const [video, setvideo] = useState('')
  const [visible, setvisible] = useState()

  // ******************************************* Photo

  const [Loading, setLoading] = useState()
  const convertBase64 = file => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(file)
      fileReader.onload = () => {
        resolve(fileReader.result)
      }
      fileReader.onerror = error => {
        reject(error)
      }
    })
  }
  function uploadSinglePhoto(base64) {
    setLoading(true)
    axios
      .post(
        `${baseUrl.baseUrl}/uploadImage`,
        { image: base64 },
        {
          headers: {}
        }
      )
      .then(res => {
        setcoverPicture(res.data)
        alert('image uploaded Succesfully')
      })
      .then(() => setLoading(false))
      .catch(console.log)
  }
  const HandleFileInputChangePhoto = async event => {
    const files = event.target.files
    console.log(files.length)
    if (files.length === 1) {
      const base64 = await convertBase64(files[0])
      uploadSinglePhoto(base64)
      return
    }
    const base64s = []
    for (var i = 0; i < files.length; i++) {
      var base = await convertBase64(files[i])
      base64s.push(base)
    }
  }
  // **************************************************Vidéo
  function uploadSingleVideo(base64) {
    setLoading(true)
    axios
      .post(`${baseUrl.baseUrl}/uploadImage`, { image: base64 })
      .then(res => {
        setvideo(res.data)
        alert('image uploaded Succesfully')
      })
      .then(() => setLoading(false))
      .catch(console.log)
  }
  const HandleFileInputChangeVideo = async event => {
    const files = event.target.files
    console.log(files.length)
    if (files.length === 1) {
      const base64 = await convertBase64(files[0])
      uploadSingleVideo(base64)
      return
    }
    const base64s = []
    for (var i = 0; i < files.length; i++) {
      var base = await convertBase64(files[i])
      base64s.push(base)
    }
  }
  // ***************************************************Audio
  function uploadSingleAudio(base64) {
    setLoading(true)
    axios
      .post(`${baseUrl.baseUrl}/uploadImage`, { image: base64 })
      .then(res => {
        setaudio(res.data)
        alert('image uploaded Succesfully')
      })
      .then(() => setLoading(false))
      .catch(console.log)
  }
  const HandleFileInputChangeAudio = async event => {
    const files = event.target.files
    console.log(files.length)
    if (files.length === 1) {
      const base64 = await convertBase64(files[0])
      uploadSingleAudio(base64)
      return
    }
    const base64s = []
    for (var i = 0; i < files.length; i++) {
      var base = await convertBase64(files[i])
      base64s.push(base)
    }
  }

  const [search, setsearch] = useState('')
  const [EnseignementList, setEnseignementList] = useState([])
  const [SearchEnseignementList, setSearchEnseignementList] = useState([])
  useEffect(() => {
    LoadAllSchool(setEnseignementList)
    LoadAllSchool(setSearchEnseignementList)
  }, [])

  // Recherche
  const HandleSearch = e => {
    setsearch(e.target.value)
  }

  return (
    <div>
      <div class='w-full container-fluid py-5'>
        <div class='w-full flex space-x-3 justify-between mb-5'>
          <div class='input-group'>
            <input
              type='text'
              class='form-control p-1 translatable'
              placeholder='rechercher enseignement ...'
            />
            <button class='btn btn-primary px-4'>
              <i class='bi bi-search'></i>
            </button>
          </div>
          {/* Ajouter button */}
          <button
            class='btn btn-primary px-4'
            data-bs-toggle='modal'
            data-bs-target='#addModal'
          >
            Ajouter
          </button>
        </div>
        {/* Modal Add Event */}
        <ModalAddSchoolBible />

        <div class='w-full '>
          {/* <button type="button" className="btn btn-outline-primary py-1 px-2" data-bs-toggle="modal" data-bs-target="#updateModal">modifier</button> */}

          <div class='w-full blog-item mb-5'>
            {EnseignementList && EnseignementList.length > 0 ? (
              EnseignementList.map(item => {
                return (
                  <div class='max-w-sm w-full lg:max-w-full lg:flex'>
                    <div
                      class='h-48 lg:h-auto lg:w-48 flex-none bg-cover rounded-t lg:rounded-t-none lg:rounded-l text-center overflow-hidden'
                      style={{ backgroundImage: `url('${item.coverPicture}')` }}
                      title='Woman holding a mug'
                    ></div>
                    <div class='border-r border-b border-l border-gray-400 lg:border-l-0 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal'>
                      <div class='mb-8'>
                        <p class={`text-sm ${item && item.visible ? "text-green-600":"text-red-600"} flex items-center`}>
                          {
                            item && item.visible ? <MdOutlineRemoveRedEye  className="text-green-600"size={20}/>:<ImBlocked className="text-red-600"size={20}/>
                          }
                          <strong> <span>{item && item.visible ? " visible ":" bloquer "} </span></strong>
                        </p>
                        <div class='text-gray-900 font-bold text-xl mb-2 translatable'>
                          {item.title}
                        </div>
                        <p class='text-gray-700 text-base translatable'>
                          {item.description}
                        </p>
                      </div>
                      <div class='flex items-center'>
                        <div class='mx-3 flex space-x-3'>
                          <button
                            type='button'
                            class='btn btn-outline-success translatable'
                            data-bs-toggle='modal'
                            data-bs-target='#audioModal'
                            onClick={() => {
                              setidSchool(item._id)
                              settitle(item.title)
                              setdescription(item.description)
                              setcoverPicture(item.coverPicture)
                              setvideo(item.video)
                              setaudio(item.audio)
                              setvisible(item.visible)
                            }}
                          >
                            modifier
                          </button>
                        </div>
                      </div>
                    </div>
                    {/* Modal Event */}
                    <div
                      class=' modal fade '
                      id='audioModal'
                      tabIndex='-2'
                      aria-labelledby='exampleModalLabel'
                      aria-hidden='true'
                    >
                      <div class='modal-dialog'>
                        <div class='modal-content rounded-0'>
                          <div class='modal-header relative'>
                            <h6
                              class=' modal-title  text-primary text-uppercase display-7 text-uppercase mb-0 translatable'
                              id='exampleModalLabel'
                              style={{ maxWidth: '600px' }}
                            >
                              Modifier
                            </h6>
                            <button
                              type='button'
                              class='absolute top-3 right-4 btn btn-close text-2xl '
                              data-bs-dismiss='modal'
                              aria-label='Close'
                            >
                              X
                            </button>
                          </div>
                          <div class='modal-body h-[600px] container flex justify-center'>
                            <div class='flex justify-center row g-8'>
                              <div class='col-lg-9'>
                                <form
                                  onSubmit={e => {
                                    e.preventDefault()
                                    UpdateSchool(
                                      idSchool,
                                      title,
                                      coverPicture,
                                      description,
                                      video,
                                      audio,
                                      visible,
                                      navigate
                                    )
                                  }}
                                >
                                  <div class='row g-3'>
                                    <div class='col-12 flex'>
                                      <label
                                        class='form-control border-0 px-4 translatable'
                                        style={{ height: '40px' }}
                                      >
                                        titre
                                      </label>
                                      <input
                                        type='text'
                                        value={title}
                                        onChange={e => {
                                          settitle(e.target.value)
                                        }}
                                        required
                                        class='form-control bg-light border-0 px-4 translatable'
                                        placeholder='titre de la vidéo'
                                        style={{ height: '40px' }}
                                      />
                                    </div>
                                    <div class='col-12 flex'>
                                      <label
                                        class='form-control border-0 px-4 translatable'
                                        style={{ height: '40px' }}
                                      >
                                        Image
                                      </label>
                                      <input
                                        type='file'
                                        onChange={HandleFileInputChangePhoto}
                                        class='form-control bg-light border-0 px-4'
                                        accept='.JPEG , .JPG'
                                        placeholder='image'
                                        style={{ height: '40px' }}
                                      />
                                      <img
                                        src={`${coverPicture}`}
                                        class='h-[50px] h-[50px]'
                                      />
                                    </div>
                                    <div class='col-12 flex'>
                                      <label
                                        class='form-control border-0 px-4 translatable'
                                        style={{ height: '40px' }}
                                      >
                                        Video (25 mb max)
                                      </label>
                                      <input
                                        type='file'
                                        onChange={HandleFileInputChangeVideo}
                                        class='form-control bg-light border-0 px-4 translatable'
                                        accept='.MP4'
                                        placeholder='vidéo'
                                        style={{ height: '40px' }}
                                      />
                                      {video && (
                                        <p class='text-success translatable'>vidéo upload</p>
                                      )}
                                    </div>
                                    <div class='col-12 flex'>
                                      <label
                                        class='form-control border-0 px-4 translatable'
                                        style={{ height: '40px' }}
                                      >
                                        Audio
                                      </label>
                                      <input
                                        type='file'
                                        onChange={HandleFileInputChangeAudio}
                                        class='form-control bg-light border-0 px-4 translatable'
                                        accept='.MP3'
                                        placeholder='audio'
                                        style={{ height: '40px' }}
                                      />
                                      {audio && (
                                        <p class='text-success translatable'>audio upload</p>
                                      )}
                                    </div>
                                    <div class='col-12'>
                                      <label
                                        class='form-control border-0 px-4 translatable'
                                        style={{ height: '40px' }}
                                      >
                                        Description
                                      </label>
                                      <textarea
                                        value={description}
                                        onChange={e => {
                                          setdescription(e.target.value)
                                        }}
                                        required
                                        class='form-control bg-light border-0 px-4 translatable'
                                        placeholder='description evenement'
                                        style={{ height: '155px' }}
                                      />
                                    </div>
                                    <div class='col-12 flex items-center'>
                                      <label
                                        class='form-control border-0 px-2 translatable'
                                        style={{ height: '40px' }}
                                      >
                                        visibilité
                                      </label>
                                      <input
                                        type='checkbox'
                                        class='form-check-input form-control border-0 px-4 translatable'
                                        checked={visible}
                                        onChange={e => {
                                          setvisible(e.currentTarget.checked)
                                          console.log(visible)
                                        }}
                                        placeholder='date'
                                        style={{ height: '40px' }}
                                      />
                                    </div>
                                    <div class='col-12'>
                                      <button
                                        class='btn btn-outline-primary w-100 py-3 translatable'
                                        type='submit'
                                      >
                                        Modifier
                                      </button>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })
            ) : (
              <LoaderBootStrap />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
export default ListSchoolBibleAdmin
